import React from 'react';
import {inject, observer } from 'mobx-react';
import { observe } from 'mobx';
import HttpClient from 'services/HttpClient';
import classNames from 'classnames';
import {Switch, Route, Link} from 'react-router-dom';
import EditPassword from 'components/my_profile/EditPassword';
import EditProfile from 'components/my_profile/EditProfile';
import NoAvaBig from 'styles/img/Placeholder user.svg';
const UPDATE_USER = '/api/v1/users/update_profile';

@inject('user')
@observer
export default class MyProfile extends React.Component {

  state = {type: 'editprofile'};

  componentWillMount = () => {
    this.setState({avatar_url: this.props.user.getUser().avatar_url});
    this.unSubscribe = observe(this.props.user, this.handleNewUser);
    this.handlePathName(this.props.location);
    this.routerListener = this.props.history.listen((location, action) => {
      this.handlePathName(location);
    });
  };

  handleNewUser = newUser => {
    if(newUser.newValue != null)
      this.setState({avatar_url: newUser.newValue.avatar_url })
  };

  handlePathName = location => {
    if(location.pathname.includes('editprofile')){
      this.setState({type: 'editprofile'})
    }
    if(location.pathname.includes('editpassword'))
      this.setState({type: 'editpassword'})
  };

  handleImagePreview = e => {
    if (e.target.files && e.target.files[0]) {
        let reader = new FileReader();
        reader.onload = e =>  {
          this.updateImage(e.target.result);
        };
        reader.readAsDataURL(e.target.files[0]);
    }
  };

  getUserAvatar = () => {
    if(this.state.avatar_url)
      return <img src={this.state.avatar_url} />;
    return <img src={NoAvaBig} className="no-ava" alt="avatar"/>
  };

  updateImage = image => {
    let formData = new FormData();
    formData.append('user[avatar]', image);
    new HttpClient().multipart(UPDATE_USER, formData, 'PUT' ).then( response => this.props.user.setUser(response.body.data.user));
  };

  componentWillUnmount = () => {
    this.routerListener();
    this.unSubscribe();
  };

  render(){
    return(
        <div className="container-fluid">
            <div className="user-profile row">
                <div className="col">
                    <div className="row  align-items-center justify-content-center user-profile-form-holder">
                        <div className="col-12 col-md-4">
                            <div className="form-holder">
                                <div className="row">
                                    <div className="col">
                                        <div className="user-profile-avatar-holder">
                                            <div className="user-profile-avatar">
                                                {
                                                  this.getUserAvatar()
                                                }
                                            </div>
                                            <div className="user-profile-name-holder">
                                                <p className="user-profile-name">{`${this.props.user.getUser().first_name}  ${this.props.user.getUser().last_name}` }</p>
                                              <label htmlFor="myProfileAvatar">
                                                <span className="user-profile-change">change</span>
                                                <span className="user-profile-change hide">add PHOTO</span>
                                              </label>
                                                <input id="myProfileAvatar" onChange={this.handleImagePreview} type="file" name="" style={{display: 'none'}}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                      <Link to="/myprofile/editprofile">
                                        <p className={classNames({'user-profile-checker': true, active: this.state.type === 'editprofile'})}>
                                            profile
                                        </p>
                                      </Link>
                                    </div>
                                    {this.props.user.user.role !== 'iacp' && <div className="col-6">
                                      <Link to="/myprofile/editpassword">
                                        <p className={classNames({'user-profile-checker': true, active: this.state.type === 'editpassword' })}>
                                          password</p>
                                      </Link>
                                    </div>}
                                </div>

                               <Switch>
                                 <Route path="/myprofile/editpassword" component={EditPassword}/>
                                 <Route path="/myprofile/editprofile" component={EditProfile}/>
                               </Switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/my_profile/MyProfile.jsx